/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Drill = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M14 9c0 .6-.4 1-1 1H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9c.6 0 1 .4 1 1Z" }],
    ["path", { d: "M18 6h4" }],
    ["path", { d: "M14 4h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3" }],
    ["path", { d: "m5 10-2 8" }],
    ["path", { d: "M12 10v3c0 .6-.4 1-1 1H8" }],
    ["path", { d: "m7 18 2-8" }],
    ["path", { d: "M5 22c-1.7 0-3-1.3-3-3 0-.6.4-1 1-1h7c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1Z" }]
  ]
];

export { Drill as default };
//# sourceMappingURL=drill.js.map
